module.exports = __webpack_public_path__ + "img/btn4.png";